import { render, staticRenderFns } from "./ConceptosLayout.vue?vue&type=template&id=bb73d8f4&scoped=true"
import script from "./ConceptosLayout.vue?vue&type=script&lang=js"
export * from "./ConceptosLayout.vue?vue&type=script&lang=js"
import style0 from "./ConceptosLayout.vue?vue&type=style&index=0&id=bb73d8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb73d8f4",
  null
  
)

export default component.exports